import { useState } from "react";
import { msalInstanceAzureAD, azureADConfig } from "../../authConfig";

interface Props {
    disabled?: boolean;
}

export const LoginButton = ({ disabled = false }: Props) => {
    const [isSigningIn, setIsSigningIn] = useState(false);
    const isBusy = disabled || isSigningIn;

    const handleAzureADLogin = async () => {
        if (isBusy) {
            return;
        }
        setIsSigningIn(true);
        try {
            // The active auth type and signed-in state are set by the AuthProvider's
            // LOGIN_SUCCESS event callback, so no manual bookkeeping is needed here.
            //
            // When using popup and silent APIs, the redirectUri should point at a blank
            // page that does not implement MSAL. The route must be registered with the app.
            await msalInstanceAzureAD.loginPopup({
                ...azureADConfig.loginRequest,
                redirectUri: "/redirect"
            });
        } catch (error) {
            console.error("Azure AD login error:", error);
        } finally {
            setIsSigningIn(false);
        }
    };

    return (
        <div className="flex gap-2">
            <button
                type="button"
                className={
                    "flex items-center justify-center h-[40px] pl-[17px] pr-[15px] rounded-button border-2 " +
                    (isBusy
                        ? "bg-jtc-pink/60 border-jtc-pink/60 text-jtc-white cursor-default"
                        : "bg-jtc-pink hover:bg-jtc-white hover:text-jtc-purple border-jtc-pink text-jtc-white cursor-pointer")
                }
                onClick={handleAzureADLogin}
                disabled={isBusy}
            >
                <div className="font-black tracking-[0.15rem] text-[.75rem] uppercase">
                    {isSigningIn ? "Signing in..." : "JTC Login"}
                </div>
            </button>
        </div>
    );
};
